import { createSelector } from 'reselect';
export const selectContentTheme = state => state.theme;
export const selectContentSchema = state => state.contentSchema;
export const selectContentThemePath = createSelector(selectContentTheme, contentTheme => {
  if (contentTheme && contentTheme.themeSettings) {
    return contentTheme.themeSettings.path;
  }
  return null;
});
export const selectContentTemplatePath = createSelector(selectContentSchema, contentSchema => {
  if (contentSchema && contentSchema.content) {
    return contentSchema.content.templatePath;
  }
  return null;
});